export default __webpack_public_path__ + "static/media/BM_RenderCamera_06_WideKitchen+Interior+Light_Scheme+Kitchen+Laundry.58503b33.jpg";